module.exports = __webpack_public_path__ + "img/make-a-backup.e461a34b.svg";